import React from "react";
import PropTypes from "prop-types";

import Number from "./layout/number";
import Button from "./layout/button";

import "../styles/numberGrid.scss";
import Icon from "./layout/icon";

const PAGE_LENGTH = 100;

export default class NumberGrid extends React.Component {
  constructor(props) {
    super(props);

    /**
     * @type {{
     *  array: number,
     *  sectionLength: number,
     *  selections: number[],
     *  onSelect: () => void,
     *  onDeselect: () => void,
     *  disabledNumbers: number[],
     * allowMultiSelection: boolean,
     * onDeselectNumber: () => void,
     * }}
     */
    this.props;

    const { array: numberArray, sectionLength } = props;

    /**
     * @type {{
     *  numbers: number[],
     *  start: number,
     *  end: number,
     *  active: false,
     * }[]}
     */
    const sectionedNumberArrays = numberArray.reduce(
      (newArray, currentNumber, index) => {
        let sectionIndex = Math.floor(index / sectionLength);

        if (sectionIndex >= newArray.length) {
          const nextSection = {
            numbers: [],
            start: currentNumber,
            end:
              Math.min(numberArray.length, currentNumber + sectionLength) - 1,
            active: false,
          };

          const currentSection = newArray[newArray.length - 1];

          if (nextSection.start === nextSection.end) {
            if (currentSection) {
              currentSection.end++;
              sectionIndex--;
            }
          } else {
            newArray.push(nextSection);
          }
        }

        if (newArray[sectionIndex])
          newArray[sectionIndex].numbers.push(currentNumber);
        return newArray;
      },
      []
    );

    /**
     * @type {{
     *  sections: {
     *      numbers: number[],
     *      start: number,
     *      end: number,
     *      active: boolean
     *  }[],
     *  allSections: {
     *      numbers: number[],
     *      start: number,
     *      end: number,
     *      active: boolean
     *  }[],
     *  shouldDivideInSections: boolean
     * }}
     */
    this.state = {
      sections: sectionedNumberArrays,
      allSections: [
        {
          numbers: numberArray,
          start: 0,
          end: numberArray.length - 1,
          active: true,
        },
      ],
      shouldDivideInSections: true,
      currentPage: 0,
    };
  }

  render() {
    const {
      array: numberArray,
      onSelect,
      sectionLength,
      disabledNumbers,
      allowMultiSelection,
      selections,
      onDeselectNumber,
    } = this.props;
    
    const { currentPage } = this.state;
    const pageAmount = Math.ceil(numberArray.length / PAGE_LENGTH);
    const numberLength = Math.ceil(Math.log10(numberArray.length));

    const currentPageNumbers = numberArray.slice(
      currentPage * PAGE_LENGTH,
      (currentPage + 1) * PAGE_LENGTH
    );

    const getRange = (page) => {
      const min = numberArray[0];
      const max = numberArray[numberArray.length - 1];
      return [
        min + page * PAGE_LENGTH,
        Math.min(max, min + (page + 1) * PAGE_LENGTH - 1)
      ];
    };

    const pageArrays = (() => {
      /**
       * @type {number[]}
       */
      const pageList = [0, currentPage - 2, currentPage - 1, currentPage, currentPage + 1, currentPage + 2, pageAmount - 1]
        .filter(number => number >= 0 && number < pageAmount)
        .reduce((duplicates, currentItem) => duplicates.includes(currentItem) ? duplicates : [...duplicates, currentItem], [])
        .sort((a, b) => a - b);

      const sectionedPageList = pageList.reduce((sections, currentNumber) => {
        const lastSection = sections[sections.length - 1];
        const lastNumber = lastSection ? lastSection[lastSection.length - 1] : undefined;

        if (currentNumber - lastNumber === 1) lastSection.push(currentNumber);
        else sections.push([currentNumber]);

        return sections;
      }, []);

      return sectionedPageList;
    })();

    return (
      <React.Fragment>
        { pageAmount > 1 && 
          <div class="number-section-list">
            {pageArrays.map((currentPageArray, i) => 
              <React.Fragment>
              {i > 0 && <div className="number-section-divider">. . .</div>}
              {currentPageArray.map(pageNumber => 
                <div className="number-section-display">
                  <div
                    className={`number-section-display__tab ${currentPage === pageNumber
                        ? "number-section-display__tab--active"
                        : ""
                      }`}
                    onClick={() => this.setState({ currentPage: pageNumber })}
                  >
                    {getRange(pageNumber)[0].toString()}
                  </div>
                </div>
                )}
              </React.Fragment>
            )}
          </div>
        }
        <div className="number-grid">
          {currentPageNumbers.map(number => {
            const buttonText = number
              .toString()
              .padStart(numberLength, "0");

            const isSelected = selections.includes(number);

            return (
              <React.Fragment>
                <Number
                  onClick={() => {
                    onSelect(number);

                    if (isSelected && !allowMultiSelection) {
                      onDeselectNumber(number);
                    }
                  }}
                  selected={isSelected}
                  disabled={disabledNumbers[buttonText]}
                >
                  {buttonText}
                </Number>
              </React.Fragment>
            );
          })}
        </div>
      </React.Fragment>
    );
  }

  toggleSection(sectionIndex) {
    const allSections = this.state.sections;
    const section = allSections[sectionIndex];
    section.active = !section.active;

    this.setState({
      ...this.state,
    });
  }

  toggleAllSections() {
    this.setState({
      ...this.state,
      shouldDivideInSections: !this.state.shouldDivideInSections,
    });
  }
}

NumberGrid.propTypes = {
  array: PropTypes.arrayOf(PropTypes.number),
  selections: PropTypes.arrayOf(PropTypes.number),
  onSelect: PropTypes.func,
  onDeselect: PropTypes.func,
  sectionLength: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/rifa/components/numberGrid.jsx